import ApplicationSerializer from "./application";
import { EmbeddedRecordsMixin } from "@ember-data/serializer/rest";
import ENV from "glesys-controlpanel/config/environment";

export default class DnsDomainSerializer extends ApplicationSerializer.extend(EmbeddedRecordsMixin) {
  usesProxy = true;

  primaryKey = "domainname";

  attrs = {
    dnssecRecords: {
      serialize: false,
      deserialize: "records",
    },
    project: "projectkey",
  };

  normalize(modelClass, resourceHash, prop) {
    const dnssecRecords = resourceHash.dnssec?.records?.map((record) => ({
      ...record,
      domain: resourceHash.domainname,
    }));

    resourceHash.dnssecRecords = dnssecRecords;

    if (resourceHash.dnssec?.records) {
      delete resourceHash.dnssec.records;
    }

    resourceHash.links = {
      records: `${ENV.apiBaseUri}/domain/listrecords?domainname=${resourceHash.domainname}`,
    };

    return super.normalize(modelClass, resourceHash, prop);
  }
}
